import React from "react";
import AppModal from "../../../AppModal";
import ClockIcon from "../../../../assets/icons/clock";
import AppButton from "../../../AppButton";
import "./RequestSuccessModal.css";

interface RequestSuccessModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const RequestSuccessModal: React.FC<RequestSuccessModalProps> = ({
  isVisible,
  onClose,
}) => {
  return (
    <AppModal
      className="request-success-modal"
      isVisible={isVisible}
      onChange={onClose}
    >
      <div className="success-modal">
        <div className="icon">
          <ClockIcon />
        </div>
        <h2 className="title">Request received!</h2>
        <p className="subtitle">We'll be in touch soon!</p>
        <AppButton variant="third" onClick={onClose}>
          OK
        </AppButton>
      </div>
    </AppModal>
  );
};

export default RequestSuccessModal;
